<template>
  <b-card class="change-phone-form" :title="header">
    <b-card-sub-title class="mb-2"
      >{{ subheader }}
      {{
        currentStep === steps['code'].value ? form.phone_number : null
      }}</b-card-sub-title
    >

    <b-form class="form" onkeydown="return event.key != 'Enter'">
      <b-form-group v-if="currentStep === steps['verify'].value">
        <custom-input
          ref="password"
          type="password"
          placeholder="Password"
          v-model="form.password"
          autofocus
          required
          :disabled="form.$busy"
          :is-invalid="form.$getError('password')"
          @keyup.enter="nextStep"
        ></custom-input>
      </b-form-group>

      <b-form-group v-else-if="currentStep === steps['new'].value">
        <custom-input
          ref="new_phone"
          type="text"
          placeholder="New Phone number"
          v-model="form.phone_number"
          required
          :disabled="form.$busy"
          :is-invalid="form.$getError('phone_number')"
          @keyup.enter="nextStep"
        ></custom-input>
      </b-form-group>

      <b-form-group v-else>
        <code-input
          ref="code"
          v-model="form.code"
          :loading="form.$busy"
          :field-width="42.5"
          :field-height="42.5"
          :is-invalid="form.$getError('token')"
          required
          @complete="nextStep"
        ></code-input>
      </b-form-group>

      <error-message
        class="mb-2 mt-3"
        sign=""
        :error="
          form.$getError('password') ||
            form.$getError('phone_number') ||
            form.$getError('token') ||
            form.$errorMessage
        "
      ></error-message>

      <hr class="card-divider" />

      <div class="modal__footer">
        <resend-verification-code-form
          v-if="currentStep === steps['code'].value"
          :form="form"
          to="phone"
          class="forgot-btn mt-3"
        >
        </resend-verification-code-form>
        <p v-else class="forgot-btn mt-3" @click="$refs.forgot.show()">
          Forgot Password?
        </p>
        <forgot-password-form ref="forgot"></forgot-password-form>

        <div class="modal__btns">
          <b-button
            variant="outline-secondary"
            :to="{ name: 'user.settings-page', params: { tab: 3 } }"
            >Discard</b-button
          >
          <b-button variant="primary" :disabled="form.$busy" @click="nextStep">
            <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;{{
              buttonText
            }}
          </b-button>
        </div>
      </div>
    </b-form>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Change phone form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import CustomInput from '@/components/inputs/CustomInput'
import ErrorMessage from '@/components/inputs/ErrorMessage'
import CodeInput from '@/components/inputs/CodeInput'
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue'
import ResendVerificationCodeForm from '@/components/forms/ResendVerificationCodeForm.vue'

export default {
  components: {
    CustomInput,
    ErrorMessage,
    CodeInput,
    ForgotPasswordForm,
    ResendVerificationCodeForm
  },
  data: function() {
    return {
      form: new Form({
        phone_number: null,
        password: null,
        code: null
      }),

      header: null,
      subheader: null,
      buttonText: null,
      currentStep: null,
      steps: {
        verify: {
          value: 1,
          header: 'Verify Password',
          subheader: 'Enter your current password to change your phone number',
          buttonText: 'Continue'
        },
        new: {
          value: 2,
          header: 'New Phone number',
          subheader: 'Enter your new phone number',
          buttonText: 'Continue'
        },
        code: {
          value: 3,
          header: 'Verify Phone number',
          subheader: 'Input the code sent to: ',
          buttonText: 'Change phone number'
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      requestChangePhone: 'auth/requestChangePhone',
      verifyChangePhone: 'auth/verifyChangePhone'
    }),
    nextStep() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      switch (this.currentStep) {
        case this.steps['verify'].value:
          this.verifyPassword()
          break
        case this.steps['new'].value:
          this.changePhoneRequest()
          break
        case this.steps['code'].value:
          this.changePhoneVerify()
          break
      }
    },

    async verifyPassword() {
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.form.$setLoading(false)
          this.setStep(this.steps['new'])
          this.setFocus('new_phone')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.setFocus('password')
        })
    },

    async changePhoneRequest() {
      await this.requestChangePhone({
        phone_number: this.form.phone_number
      })
        .then(() => {
          this.form.$setLoading(false)
          this.setStep(this.steps['code'])
          this.setFocus('code')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.setFocus('new_phone')
        })
    },

    async changePhoneVerify() {
      await this.verifyChangePhone({
        token: this.form.code
      })
        .then(() => {
          this.$router.push({
            name: 'user.settings-page',
            params: {
              tab: 3,
              alert: {
                label: 'Your phone number has been updated'
              }
            }
          })
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.setFocus('code')
        })
    },

    setStep(obj) {
      this.currentStep = obj.value
      this.header = obj.header
      this.subheader = obj.subheader
      this.buttonText = obj.buttonText
    },

    setFocus(ref) {
      this.$nextTick(() => {
        if (!this.$refs[ref]) return
        this.$refs[ref].focus()
      })
    }
  },

  created() {
    this.setStep(this.steps['verify'])
  }
}
</script>
<style scoped lang="scss">
.change-phone-form {
}
</style>
